module.exports = __webpack_public_path__ + "static/media/1837.e8b4f48a.jpg";